"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = {
    Simple: { LANGUAGE: 'Language' },
    RECORD: 'Record',
    DOSE: 'Dose',
    PHU_INTEGRATION: 'PHUIntegration',
    PHU_CONFIG: 'PHUConfig',
    CONSENT: 'Consent',
    VACCINE: 'Vaccine',
    DISEASE: 'Disease',
    SCHEDULE: 'Schedule',
    COLLECTION: 'Collection',
    GENERATOR: 'Generator',
    GENERIC_CONCEPT: 'GenericConcept',
    TRADE_NAME_CONCEPT: 'TradeNameConcept',
    DISEASE_CONCEPT: 'DiseaseConcept',
    CITY: 'City',
    BANNER: 'Banner'
};
//# sourceMappingURL=Type.js.map